module.exports = __webpack_public_path__ + "img/support-section-background.feca326b.svg";